import { axios } from '../axios';
import { baseEnvironment } from '../environment/environment.base';

const v3Version = baseEnvironment.apiVersion3;
const listRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeonForms.list}`;
const detailsRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeonForms.details}`;
const downloadRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeonForms.download}`;
const uploadRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeonForms.upload}`;
const downloadSignedRoute = `${v3Version}${baseEnvironment.apiEndPoints.surgeonForms.downloadSigned}`;

export const getAllSurgeonForms = async (searchText = ''): Promise<any> => {
  const response = await axios.get(listRoute, {
    params: {
      search_text: searchText
    }
  });
  return response.data;
};

export const getSurgeonFormById = async (id: string | number): Promise<any> => {
  const endPoint = detailsRoute.replace(':id', String(id));
  const response = await axios.get(endPoint);
  return response.data;
};

export const downloadSurgeonFormById = async (id: string | number): Promise<any> => {
  const endPoint = downloadRoute.replace(':id', String(id));
  const response = await axios.get(endPoint);
  return response.data;
};

export const uploadSurgeonForm = async (payload: {
  form_name: string;
  file?: File;
  file_id?: number;
  form_id?: number;
  surgeon_ids?: number[];
}): Promise<any> => {
  if (!payload.file && payload.file_id) {
    const response = await axios.post(uploadRoute, {
      form_id: payload.form_id,
      form_name: payload.form_name,
      file_id: payload.file_id,
      surgeon_ids: payload.surgeon_ids || []
    });
    return response.data;
  }

  const formData = new FormData();
  formData.append('form_name', payload.form_name);
  if (payload.file) {
    formData.append('file', payload.file);
  }
  if (payload.form_id) {
    formData.append('form_id', String(payload.form_id));
  }
  if (Array.isArray(payload.surgeon_ids) && payload.surgeon_ids.length > 0) {
    formData.append('surgeon_ids', JSON.stringify(payload.surgeon_ids));
  }
  const response = await axios.post(uploadRoute, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const getSurgeonsList = async (searchText = ''): Promise<any> => {
  const response = await axios.get(`/${listRoute}/surgeons`, {
    params: {
        search_text: searchText
    }
  });

  return {
    surgeons: response.data?.surgeons || response.data?.data?.surgeons || []
  };
};

export const getFormsBySurgeonId = async (surgeonId: string | number): Promise<any> => {
  const response = await axios.get(`/${listRoute}/by-surgeon/${surgeonId}`);
  return response.data;
};

export const uploadSignedSurgeonForm = async (surgeonId: number, formId: number, file: any): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`/${listRoute}/${surgeonId}/form/${formId}/upload-signed`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

export const downloadSignedSurgeonFormById = async (surgeonId: number, formId: number): Promise<any> => {
    const response = await axios.get(`/${listRoute}/${surgeonId}/form/${formId}/download`);
    return response.data;
};

export const sendSignedSurgeonFormToUsmon = async (surgeonId: number, formId: number): Promise<any> => {
    const response = await axios.post(`/${listRoute}/${surgeonId}/form/${formId}/send-to-usmon`);
    return response.data;
};

export const downloadSignedSurgeonForm = async (
  surgeonId: string | number,
  formId: string | number
): Promise<any> => {
  const endPoint = downloadSignedRoute
    .replace(':surgeon_id', String(surgeonId))
    .replace(':form_id', String(formId));
  const response = await axios.get(endPoint);
  return response.data;
};
